export default{
  "uploadButtonText": "点击上传",
  "uploadTip": "只能上传jpg/png文件，且不超过10MB",
  "exceedLimitMessage": "最多只能上传{maxCount}张图片",

  "app.name": "Hello uni-app",
  "user.title": "我的",
  "cart.title": "购物车",
  "kind.title": "种类",
  "shop.title": "店铺",
  "switch.title": "切换",
  "applySuccess": "申请成功",
  router: {
    home: '首页',
    pay: '支付',
    shop: 'Shop',
    user: '用户',
    userList: '用户列表',
    menuShop: '商店',
    shopList: '商店列表',
    addShop: '添加商店',
    updateShop: '更新商店',
    product: '商品',
    productList: '商品列表',
    addProduct: '添加商品',
    updateProduct: '修改商品',
    productCate: '商品分类',
    addProductCate: '添加商品分类',
    updateProductCate: '修改商品分类',
    productAttr: '商品类型',
    productAttrList: '商品属性列表',
    addProductAttr: '添加商品属性',
    updateProductAttr: '修改商品属性',
    brand: '品牌管理',
    addBrand: '添加品牌',
    updateBrand: '编辑品牌',
    order: '订单',
    orderList: '订单列表',
    orderDetail: '订单详情',
    deliverOrderList: '发货列表',
    orderSetting: '订单设置',
    returnApply: '退货申请处理',
    returnReason: '退货原因设置',
    returnApplyDetail: '退货原因详情',
    marketing: '营销',
    flashSale: '秒杀活动列表',
    flashSession: '秒杀时间段列表',
    selectSession: '秒杀时间段选择',
    flashProductRelation: '秒杀商品列表',
    couponList: '优惠券列表',
    addCoupon: '添加优惠券',
    updateCoupon: '修改优惠券',
    couponHistory: '优惠券领取详情',
    brandRecommendation: '品牌推荐',
    newProduct: '新品推荐',
    popularProduct: '人气推荐',
    specialTopic: '专题推荐',
    advertiseList: '广告列表',
    addAdvertise: '添加广告',
    editAdvertise: '编辑广告',
    permission: '权限',
    roleList: '角色列表',
    allocMenu: '分配菜单',
    allocResource: '分配资源',
    menuList: '菜单列表',
    addMenu: '添加菜单',
    updateMenu: '修改菜单',
    resourceList: '资源列表',
    resourceCategory: '资源分类'
  },
  "uploadButtonText": "点击上传",
  "uploadTip": "只能上传 jpg/png 文件，且不超过 10MB",
  "exceedLimitMessage": "最多可上传 {maxCount} 张图片",
  "login": "登录",
  "register": "注册",

  "menuShop": "商店",
  "menuShopList": "商店列表",
  "menuShopAdd": "添加商店",
  "menuCommodity": "商品",
  "menuCommodityList": "商品列表",
  "menuCommodityAdd": "添加商品",
  "menuCommodityCategory": "商品分类",
  "menuCommodityCKind": "商品种类",
  "app.name": "Hello uni-app",
  "user.title": "我的",
  "cart.title": "购物车",
  "kind.title": "种类",
  "shop.title": "商店",
  "switch.title": "切换",
  "applySuccess": "申请成功",
  "noFound": "请验证您的代码",
  "repeatRequest": "已重复提交申请",
  "success": "成功",
  shop: {
    paypalClientId:"Paypal ClientId",
    paypalSecretKey:"Secret Key",
    barcodeTitle:"邀请链接二维码",
    appPaste:"分享APP邀请链接",
    appBarcode:"分享APP二维码",
    barcode:"分享二维码",
    autoApprove:'客户自动审批',
    paypalAccount:"Paypal账户",
    blockchainNetwork:"区块链网络",
    blockchainAddress:"钱包地址",
    select:"请选择",
    paypal:"线下Paypal",
    onlinePaypal:"线上Paypal",
    blockchain:"线下区块链",
    realName:"真实姓名",
    mobile: "手机号码",
    paymentMethod:"收款方式",
    balanceAmount: "资金数额",
    addPayment:"添加收款方式",
    searchFilter: '筛选搜索',
    searchResults: '查询结果',
    inputSearch: '输入搜索：',
    keywordPlaceholder: '关键字',
    dataList: '数据列表',
    addButton: '添加',
    id: '编号',
    paste: '分享邀请链接',
    shopName: '店铺名',
    legalPersonName: '法人姓名',
    country: '国家',
    city: '城市',
    companyName: '公司全名',
    editButton: '编辑',
    deleteButton: '删除',
    deleteConfirmation: '是否要删除该品牌',
    prompt: '提示',
    confirm: '确定',
    cancel: '取消',
    deleteSuccess: '删除成功',
    showBrand: '显示品牌',
    hideBrand: '隐藏品牌',
    name: '名称',
    auto:'自动',
    manual:'手动',
    streetLine1: '街道地址1',
    addressLine2: '街道地址2',
    firstName: '名字',
    inviteCode: '邀请码',
    lastName: '姓氏',
    phone: '手机号码（Whatsapp）',
    status: '状态',
    postcode: '邮政编码',
    currency: '货币',
    icon: '图标',
    submit: '提交',
    reset: '重置',
    enterName: '请输入名称',
    nameLength: '长度在 2 到 140 个字符',
    confirmSubmit: '是否提交数据',
    editSuccess: '修改成功',
    submitSuccess: '提交成功',
    validationFailed: '验证失败',
    selectCountry:'选择国家',
    "Afghanistan": "阿富汗",
    "Albania": "阿尔巴尼亚",
    "Algeria": "阿尔及利亚",
    "Andorra": "安道尔",
    "Angola": "安哥拉",
    "Antigua and Barbuda": "安提瓜和巴布达",
    "Argentina": "阿根廷",
    "Armenia": "亚美尼亚",
    "Australia": "澳大利亚",
    "Austria": "奥地利",
    "Azerbaijan": "阿塞拜疆",
    "Bahamas": "巴哈马",
    "Bahrain": "巴林",
    "Bangladesh": "孟加拉国",
    "Barbados": "巴巴多斯",
    "Belarus": "白俄罗斯",
    "Belgium": "比利时",
    "Belize": "伯利兹",
    "Benin": "贝宁",
    "Bhutan": "不丹",
    "Bolivia": "玻利维亚",
    "Bosnia and Herzegovina": "波斯尼亚和黑塞哥维那",
    "Botswana": "博茨瓦纳",
    "Brazil": "巴西",
    "Brunei": "文莱",
    "Bulgaria": "保加利亚",
    "Burkina Faso": "布基纳法索",
    "Burundi": "布隆迪",
    "Cambodia": "柬埔寨",
    "Cameroon": "喀麦隆",
    "Canada": "加拿大",
    "Cape Verde": "佛得角",
    "Central African Republic": "中非共和国",
    "Chad": "乍得",
    "Chile": "智利",
    "China": "中国",
    "Colombia": "哥伦比亚",
    "Comoros": "科摩罗",
    "Congo Republic": "刚果共和国",
    "Congo Democratic Republic": "刚果民主共和国",
    "Costa Rica": "哥斯达黎加",
    "Ivory Coast": "科特迪瓦",
    "Croatia": "克罗地亚",
    "Cuba": "古巴",
    "Cyprus": "塞浦路斯",
    "Czech Republic": "捷克",
    "Denmark": "丹麦",
    "Djibouti": "吉布提",
    "Dominica": "多米尼加",
    "Dominican Republic": "多米尼加共和国",
    "East Timor": "东帝汶",
    "Ecuador": "厄瓜多尔",
    "Egypt": "埃及",
    "El Salvador": "萨尔瓦多",
    "Equatorial Guinea": "赤道几内亚",
    "Eritrea": "厄立特里亚",
    "Estonia": "爱沙尼亚",
    "Eswatini": "斯威士兰",
    "Ethiopia": "埃塞俄比亚",
    "Fiji": "斐济",
    "Finland": "芬兰",
    "France": "法国",
    "Gabon": "加蓬",
    "Gambia": "冈比亚",
    "Georgia": "格鲁吉亚",
    "Germany": "德国",
    "Ghana": "加纳",
    "Greece": "希腊",
    "Grenada": "格林纳达",
    "Guatemala": "危地马拉",
    "Guinea": "几内亚",
    "Guinea-Bissau": "几内亚比绍",
    "Guyana": "圭亚那",
    "Haiti": "海地",
    "Honduras": "洪都拉斯",
    "Hungary": "匈牙利",
    "Iceland": "冰岛",
    "India": "印度",
    "Indonesia": "印度尼西亚",
    "Iran": "伊朗",
    "Iraq": "伊拉克",
    "Ireland": "爱尔兰",
    "Israel": "以色列",
    "Italy": "意大利",
    "Jamaica": "牙买加",
    "Japan": "日本",
    "Jordan": "约旦",
    "Kazakhstan": "哈萨克斯坦",
    "Kenya": "肯尼亚",
    "Kiribati": "基里巴斯",
    "South Korea": "韩国",
    "Kuwait": "科威特",
    "Kyrgyzstan": "吉尔吉斯斯坦",
    "Laos": "老挝",
    "Latvia": "拉脱维亚",
    "Lebanon": "黎巴嫩",
    "Lesotho": "莱索托",
    "Liberia": "利比里亚",
    "Libya": "利比亚",
    "Liechtenstein": "列支敦士登",
    "Lithuania": "立陶宛",
    "Luxembourg": "卢森堡",
    "Madagascar": "马达加斯加",
    "Malawi": "马拉维",
    "Malaysia": "马来西亚",
    "Maldives": "马尔代夫",
    "Mali": "马里",
    "Malta": "马耳他",
    "Marshall Islands": "马绍尔群岛",
    "Mauritania": "毛里塔尼亚",
    "Mauritius": "毛里求斯",
    "Mexico": "墨西哥",
    "Micronesia": "密克罗尼西亚",
    "Moldova": "摩尔多瓦",
    "Monaco": "摩纳哥",
    "Mongolia": "蒙古",
    "Montenegro": "黑山",
    "Morocco": "摩洛哥",
    "Mozambique": "莫桑比克",
    "Myanmar": "缅甸",
    "Namibia": "纳米比亚",
    "Nauru": "瑙鲁",
    "Nepal": "尼泊尔",
    "Netherlands": "荷兰",
    "New Zealand": "新西兰",
    "Nicaragua": "尼加拉瓜",
    "Niger": "尼日尔",
    "Nigeria": "尼日利亚",
    "North Macedonia": "北马其顿",
    "Norway": "挪威",
    "Oman": "阿曼",
    "Pakistan": "巴基斯坦",
    "Palau": "帕劳",
    "Palestine": "巴勒斯坦",
    "Panama": "巴拿马",
    "Papua New Guinea": "巴布亚新几内亚",
    "Paraguay": "巴拉圭",
    "Peru": "秘鲁",
    "Philippines": "菲律宾",
    "Poland": "波兰",
    "Portugal": "葡萄牙",
    "Qatar": "卡塔尔",
    "Romania": "罗马尼亚",
    "Russia": "俄罗斯",
    "Rwanda": "卢旺达",
    "Saint Kitts and Nevis": "圣基茨和尼维斯",
    "Saint Lucia": "圣卢西亚",
    "Saint Vincent and the Grenadines": "圣文森特和格林纳丁斯",
    "Samoa": "萨摩亚",
    "San Marino": "圣马力诺",
    "Sao Tome and Principe": "圣多美和普林西比",
    "Saudi Arabia": "沙特阿拉伯",
    "Senegal": "塞内加尔",
    "Serbia": "塞尔维亚",
    "Seychelles": "塞舌尔",
    "Sierra Leone": "塞拉利昂",
    "Singapore": "新加坡",
    "Slovakia": "斯洛伐克",
    "Slovenia": "斯洛文尼亚",
    "Solomon Islands": "所罗门群岛",
    "Somalia": "索马里",
    "South Africa": "南非",
    "South Sudan": "南苏丹",
    "Spain": "西班牙",
    "Sri Lanka": "斯里兰卡",
    "Sudan": "苏丹",
    "Suriname": "苏里南",
    "Sweden": "瑞典",
    "Switzerland": "瑞士",
    "Syria": "叙利亚",
    "Tajikistan": "塔吉克斯坦",
    "Tanzania": "坦桑尼亚",
    "Thailand": "泰国",
    "East Timor": "东帝汶",
    "Togo": "多哥",
    "Tonga": "汤加",
    "Trinidad and Tobago": "特立尼达和多巴哥",
    "Tunisia": "突尼斯",
    "Turkey": "土耳其",
    "Turkmenistan": "土库曼斯坦",
    "Tuvalu": "图瓦卢",
    "Uganda": "乌干达",
    "Ukraine": "乌克兰",
    "United Arab Emirates": "阿联酋",
    "United Kingdom": "英国",
    "United States": "美国",
    "Uruguay": "乌拉圭",
    "Uzbekistan": "乌兹别克斯坦",
    "Vanuatu": "瓦努阿图",
    "Vatican": "梵蒂冈",
    "Venezuela": "委内瑞拉",
    "Vietnam": "越南",
    "Yemen": "也门",
    "Zambia": "赞比亚",
    "Zimbabwe": "津巴布韦"
  },
  balance:{
    selectPaymentMethod: "选择支付方式",
    exceedBalance: "超出收银金额",
    chooseOrder: "选择订单",
    username: "用户名",
    realName: "真实姓名",
    mobile: "手机号码",
    amount: "收银金额",
    note: "备注",
    payType: "支付渠道",
    createTime:"创建时间",
    addOrderBtn:"增加订单",
    operations:"操作",
    cashierAmount:"收银资金",
    manualOrder: "手工绑定订单",
    relatedOrder: "关联订单",
    totalAmount: "订单总金额",
    orderNote: "订单备注",
    relatedOrders: "关联订单",
    orderTotalAmount: "订单总金额",
    collectionTime: "收款时间",
  },
  product: {
    filterSearch: '筛选查询',
    queryResults: '查询结果',
    reset: '重置',
    inputSearch: '输入搜索：',
    productSn: '产品编号：',
    productCategory: '产品类别：',
    publishStatus: '发布状态：',
    verifyStatus: '审核状态：',
    dataList: '数据列表',
    add: '添加',
    number: '序号',
    productImage: '产品图片',
    productName: '产品名称',
    priceSn: '价格/编号',
    tags: '标签',
    shelf: '上架：',
    new: '新品：',
    recommend: '推荐：',
    sort: '排序',
    skuStock: 'SKU库存',
    sale: '销量',
    operation: '操作',
    view: '查看',
    edit: '编辑',
    delete: '删除',
    batchOperation: '批量操作',
    confirm: '确认',
    cancel: '取消',
    editProductInfo: '编辑产品信息',
    productSnText: '产品编号：',
    searchBySku: '通过SKU搜索',
    skuCode: 'SKU代码',
    salePrice: '销售价格',
    productStock: '产品库存',
    lowStock: '低库存',
    successMessage: '修改成功',
    warningMessage: '无SKU信息',
    searchPlaceholder: '产品名称',
    selectPlaceholder: '请选择',
    all: '全部',
    filterOptions: {
      publishOn: '上架',
      publishOff: '下架',
      recommendOn: '推荐',
      recommendOff: '不推荐',
      newOn: '新品',
      newOff: '非新品',
      transferCategory: '转移至分类',
      recycle: '回收'
    },
    statusOptions: {
      publishOn: '上架',
      publishOff: '下架',
      verifyPassed: '审核通过',
      verifyNotPassed: '审核未通过'
    }
  },
  productIndex: {
    filterSearch: "筛选查询",
    searchResult: "查询结果",
    reset: "重置",
    inputSearch: "输入搜索：",
    productName: "产品名称",
    productSn: "产品编号：",
    productCategory: "产品类别：",
    publishStatus: "发布状态：",
    verifyStatus: "审核状态：",
    all: "全部",
    dataList: "数据列表",
    add: "添加",
    number: "序号",
    productImage: "产品图片",
    brand: "品牌",
    priceSn: "价格/编号",
    price: "价格",
    label: "标签",
    publish: "发布",
    new: "新品",
    recommend: "推荐",
    sort: "排序",
    skuStock: "SKU库存",
    sales: "销量",
    operate: "操作",
    view: "查看",
    edit: "编辑",
    delete: "删除",
    batchOperate: "批量操作",
    confirm: "确认",
    editSkuInfo: "编辑SKU信息",
    searchBySku: "通过SKU搜索",
    skuCode: "SKU代码",
    salePrice: "销售价格",
    productStock: "产品库存",
    lowStock: "低库存",
    cancel: "取消",
    noSkuInfo: "无SKU信息",
    confirmEdit: "是否确认更改？",
    prompt: "提示",
    editSuccess: "修改成功",
    selectOperateType: "请选择操作类型",
    selectProducts: "请选择要操作的产品",
    confirmBatchOperate: "是否确认进行批量操作？",
    confirmDelete: "是否确认删除操作？",
    updateSuccess: "更新成功",
    deleteSuccess: "删除成功",
    publishOn: "上架",
    publishOff: "下架",
    recommendOn: "推荐",
    recommendOff: "不推荐",
    newOn: "新品",
    newOff: "非新品",
    transferCategory: "转移至分类",
    recycle: "移至回收站",
    verifyPass: "审核通过",
    unverified: "未审核",
  },
  productAttr: {
    skuMode: "SKU模式：",
    attrType: "属性类型：",
    selectAttrType: "请选择属性类型",
    productSpec: "产品规格：",
    salePrice: "销售价格",
    promotionPrice: "促销价格",
    stock: "库存",
    lowStock: "低库存",
    skuCode: "SKU代码",
    operate: "操作",
    delete: "删除",
    add: "添加",
    refreshList: "刷新列表",
    syncPrice: "同步价格",
    syncStock: "同步库存",
    attrImage: "属性图片：",
    productParam: "产品参数：",
    productAlbum: "产品相册：",
    productDetail: "产品详情：",
    pcDetail: "PC详情",
    mobileDetail: "移动详情",
    prevStep: "上一步",
    finishCommit: "完成，提交产品",
    attrValueNotNull: "属性值不能为空",
    attrValueNotRepeat: "属性值不能重复",
    confirmRefreshList: "刷新列表将重新生成SKU信息，是否继续刷新？",
    confirmSyncPrice: "将第一个SKU的价格同步到所有SKU。是否继续？",
    confirmSyncStock: "将第一个SKU的库存同步到所有SKU。是否继续？",
    prompt: "提示",
    confirm: "确认",
    cancel: "取消"
  },
  productDetail: {
    fillProductInfo: "填写产品信息",
    fillProductPromotion: "填写产品促销",
    fillProductAttr: "填写产品属性",
    confirmSubmit: "是否确认提交该产品？",
    prompt: "提示",
    confirm: "确认",
    cancel: "取消",
    submitSuccess: "提交成功"
  },
  productInfoDetail: {
    productCategory: "产品类别：",
    productName: "产品名称：",
    subTitle: "标签：",
    productDescription: "产品描述：",
    productSn: "产品编号：",
    productPrice: "产品价格：",
    originalPrice: "原价：",
    productStock: "产品库存：",
    unit: "单位：",
    productWeight: "产品重量：",
    gram: "克",
    sort: "排序",
    nextStep: "下一步",
    enterProductName: "请输入产品名称",
    nameLength: "长度应在2到140个字符之间",
    enterSubTitle: "请输入副标题",
    selectProductCategory: "请选择产品类别",
    enterProductDescription: "请输入产品描述",
    requiredField: "此字段为必填项",
    enterContent: "请输入内容",
    validationFailed: "验证失败"
  },

  // productSaleDetail: {
  //   productPublish: "产品发布:",
  //   productRecommend: "产品推荐:",
  //   newProduct: "新品",
  //   recommend: "推荐",
  //   serviceGuarantee: "服务保障:",
  //   return: "退货",
  //   quickRefund: "快速退款",
  //   freeShipping: "包邮",
  //   detailTitle: "详情页标题:",
  //   detailDesc: "详情页描述:",
  //   keywords: "关键词:",
  //   note: "备注:",
  //   startTime: "开始时间",
  //   selectStartTime: "选择开始时间",
  //   endTime: "结束时间",
  //   selectEndTime: "选择结束时间",
  //   promotionPrice: "促销价格",
  //   enterPromotionPrice: "请输入促销价格",
  //   quantity: "数量",
  //   discount: "折扣",
  //   operate: "操作",
  //   delete: "删除",
  //   add: "添加",
  //   full: "满",
  //   reduce: "减",
  //   prevStep: "上一步，填写产品信息",
  //   nextStep: "下一步，填写产品属性",
  //   maxThreeItems: "最多可添加三项"
  // },
  // productAttrIndex: {
  //   dataList: "数据列表",
  //   add: "添加",
  //   id: "编号",
  //   typeName: "类型名称",
  //   attrCount: "属性数量",
  //   paramCount: "参数数量",
  //   settings: "设置",
  //   attrList: "属性列表",
  //   paramList: "参数列表",
  //   operations: "操作",
  //   edit: "编辑",
  //   delete: "删除",
  //   cancel: "取消",
  //   confirm: "确认",
  //   addType: "添加类型",
  //   editType: "编辑类型",
  //   enterTypeName: "请输入类型名称",
  //   confirmDelete: "确定要删除这个品牌吗？",
  //   prompt: "提示",
  //   deleteSuccess: "删除成功",
  //   addSuccess: "添加成功",
  //   editSuccess: "编辑成功"
  // },
  // productAttrList: {
  //   dataList: "数据列表",
  //   add: "添加",
  //   id: "编号",
  //   attrName: "属性名称",
  //   productType: "产品类型",
  //   selectable: "可选择",
  //   inputMethod: "输入方式",
  //   inputList: "输入列表",
  //   sort: "排序",
  //   actions: "操作",
  //   edit: "编辑",
  //   delete: "删除",
  //   batchOperation: "批量操作",
  //   confirm: "确认",
  //   selectRecord: "请选择记录",
  //   selectBatchType: "请选择批量操作类型",
  //   confirmDelete: "确定要删除这个属性吗？",
  //   prompt: "提示",
  //   deleteSuccess: "删除成功",
  //   inputFromList: "从列表中选择",
  //   manualInput: "手动输入",
  //   singleSelect: "单选",
  //   multiSelect: "多选",
  //   unique: "唯一"
  // },
  // productAttrDetail: {
  //   attrName: "属性名称:",
  //   productType: "产品类型:",
  //   selectPlaceholder: "请选择",
  //   filterStyle: "筛选样式:",
  //   normal: "普通",
  //   color: "颜色",
  //   searchable: "可搜索:",
  //   noSearch: "不可搜索",
  //   keywordSearch: "关键词搜索",
  //   rangeSearch: "范围搜索",
  //   related: "关联:",
  //   yes: "是",
  //   no: "否",
  //   selectable: "可选择:",
  //   unique: "唯一",
  //   singleSelect: "单选",
  //   multiSelect: "多选",
  //   inputMethod: "输入方式:",
  //   manualInput: "手动输入",
  //   selectFromList: "从列表中选择",
  //   inputList: "输入列表:",
  //   supportManualAdd: "支持手动添加:",
  //   sort: "排序:",
  //   submit: "提交",
  //   reset: "重置",
  //   enterAttrName: "请输入属性名称",
  //   nameLength: "长度应在2到140个字符之间",
  //   confirmSubmit: "确定要提交数据吗？",
  //   prompt: "提示",
  //   confirm: "确认",
  //   cancel: "取消",
  //   submitSuccess: "提交成功",
  //   editSuccess: "编辑成功",
  //   validationFailed: "验证失败"
  // },
  // productCate: {
  //   dataList: "数据列表",
  //   add: "添加",
  //   id: "编号",
  //   name: "名称",
  //   level: "级别",
  //   productCount: "产品数量",
  //   productUnit: "产品单位",
  //   navStatus: "导航状态",
  //   showStatus: "显示状态",
  //   sort: "排序",
  //   settings: "设置",
  //   transferProduct: "转移产品",
  //   actions: "操作",
  //   edit: "编辑",
  //   delete: "删除",
  //   confirmDelete: "确定要删除这个分类吗？",
  //   prompt: "提示",
  //   confirm: "确认",
  //   cancel: "取消",
  //   deleteSuccess: "删除成功",
  //   editSuccess: "编辑成功",
  //   level1: "一级",
  //   level2: "二级"
  // },
  // productCateDetail: {
  //   name: "分类名称:",
  //   productUnit: "数量单位:",
  //   sort: "排序:",
  //   showStatus: "显示状态:",
  //   yes: "是",
  //   no: "否",
  //   navStatus: "显示在导航中:",
  //   icon: "分类图标:",
  //   delete: "删除",
  //   add: "添加",
  //   keywords: "关键词:",
  //   description: "描述:",
  //   submit: "提交",
  //   reset: "重置",
  //   enterName: "请输入分类名称",
  //   nameLength: "长度应在2到140个字符之间",
  //   confirmSubmit: "确定要提交数据吗？",
  //   prompt: "提示",
  //   confirm: "确认",
  //   cancel: "取消",
  //   submitSuccess: "提交成功",
  //   editSuccess: "编辑成功",
  //   validationFailed: "验证失败",
  //   noParent: "无父级分类",
  //   atLeastOne: "至少保留一个",
  //   maxThree: "最多可添加三个",
  //   filterAttr: "筛选属性:"
  // },
  productSaleDetail: {
    productPublish: "产品发布:",
    productRecommend: "产品推荐:",
    newProduct: "新品",
    recommend: "推荐",
    serviceGuarantee: "服务保障:",
    return: "退货",
    quickRefund: "快速退款",
    freeShipping: "包邮",
    detailTitle: "详情页标题:",
    detailDesc: "详情页描述:",
    keywords: "关键词:",
    note: "备注:",
    startTime: "开始时间",
    selectStartTime: "选择开始时间",
    endTime: "结束时间",
    selectEndTime: "选择结束时间",
    promotionPrice: "促销价格",
    enterPromotionPrice: "请输入促销价格",
    promotionType:"价格策略：",
    quantity: "数量",
    discount: "折扣",
    operate: "操作",
    noPromotion: "统一价格",
    memberPrice: "会员价格",
    delete: "删除",
    add: "添加",
    full: "满",
    reduce: "减",
    prevStep: "上一步",
    nextStep: "下一步",
    maxThreeItems: "最多可添加三项"
  },
  productAttrIndex: {
    dataList: "数据列表",
    add: "添加",
    id: "编号",
    typeName: "类型名称",
    attrCount: "属性数量",
    paramCount: "参数数量",
    settings: "设置",
    attrList: "属性列表",
    paramList: "参数列表",
    operations: "操作",
    edit: "编辑",
    delete: "删除",
    cancel: "取消",
    confirm: "确认",
    addType: "添加类型",
    editType: "编辑类型",
    enterTypeName: "请输入类型名称",
    confirmDelete: "确定要删除这个品牌吗？",
    prompt: "提示",
    deleteSuccess: "删除成功",
    addSuccess: "添加成功",
    editSuccess: "编辑成功"
  },
  productAttrList: {
    dataList: "数据列表",
    add: "添加",
    id: "编号",
    attrName: "属性名称",
    productType: "产品类型",
    selectable: "可选择",
    inputMethod: "输入方式",
    inputList: "输入列表",
    sort: "排序",
    actions: "操作",
    edit: "编辑",
    delete: "删除",
    batchOperation: "批量操作",
    confirm: "确认",
    selectRecord: "请选择记录",
    selectBatchType: "请选择批量操作类型",
    confirmDelete: "确定要删除这个属性吗？",
    prompt: "提示",
    deleteSuccess: "删除成功",
    inputFromList: "从列表中选择",
    manualInput: "手动输入",
    singleSelect: "单选",
    multiSelect: "多选",
    unique: "唯一"
  },
  productAttrDetail: {
    stockDesp: "-1 表示库存无限制",
    attrName: "属性名称:",
    productType: "产品类型:",
    selectPlaceholder: "请选择",
    filterStyle: "筛选样式:",
    normal: "普通",
    color: "颜色",
    searchable: "可搜索:",
    noSearch: "不可搜索",
    keywordSearch: "关键词搜索",
    rangeSearch: "范围搜索",
    related: "关联:",
    yes: "是",
    no: "否",
    selectable: "可选择:",
    unique: "唯一",
    singleSelect: "单选",
    multiSelect: "多选",
    inputMethod: "输入方式:",
    manualInput: "手动输入",
    selectFromList: "从列表中选择",
    inputList: "输入列表:",
    supportManualAdd: "支持手动添加:",
    sort: "排序:",
    submit: "提交",
    reset: "重置",
    enterAttrName: "请输入属性名称",
    nameLength: "长度应在2到140个字符之间",
    confirmSubmit: "确定要提交数据吗？",
    prompt: "提示",
    confirm: "确认",
    cancel: "取消",
    submitSuccess: "提交成功",
    editSuccess: "编辑成功",
    validationFailed: "验证失败"
  },
  productCate: {
    dataList: "数据列表",
    add: "添加",
    id: "编号",
    name: "名称",
    level: "级别",
    productCount: "产品数量",
    productUnit: "产品单位",
    navStatus: "导航状态",
    showStatus: "显示状态",
    sort: "排序",
    settings: "设置",
    transferProduct: "转移产品",
    actions: "操作",
    edit: "编辑",
    delete: "删除",
    confirmDelete: "确定要删除这个分类吗？",
    prompt: "提示",
    confirm: "确认",
    cancel: "取消",
    deleteSuccess: "删除成功",
    editSuccess: "编辑成功",
    level1: "一级",
    level2: "二级"
  },
  productCateDetail: {
    name: "分类名称:",
    productUnit: "数量单位:",
    sort: "排序:",
    showStatus: "显示状态:",
    yes: "是",
    no: "否",
    navStatus: "显示在导航中:",
    icon: "分类图标:",
    delete: "删除",
    add: "添加",
    keywords: "关键词:",
    description: "描述:",
    submit: "提交",
    reset: "重置",
    enterName: "请输入分类名称",
    nameLength: "长度应在2到140个字符之间",
    confirmSubmit: "确定要提交数据吗？",
    prompt: "提示",
    confirm: "确认",
    cancel: "取消",
    submitSuccess: "提交成功",
    editSuccess: "编辑成功",
    validationFailed: "验证失败",
    noParent: "无父级分类",
    atLeastOne: "至少保留一个",
    maxThree: "最多可添加三个",
    filterAttr: "筛选属性:"
  },

  orderIndex: {
    chooseUser: "选择用户:",
    addOrder:"添加订单",
    filterSearch: "筛选搜索",
    search: "搜索",
    reset: "重置",
    inputSearch: "输入搜索:",
    orderSn: "订单编号",
    receiver: "收件人:",
    receiverNameOrPhone: "收件人姓名/电话号码",
    submitTime: "提交时间:",
    selectTime: "选择时间",
    orderStatus: "订单状态:",
    all: "全部",
    orderCategory: "订单分类:",
    orderSource: "订单来源:",
    dataList: "数据列表",
    id: "编号",
    createTime: "创建时间",
    memberUsername: "用户账户",
    totalAmount: "总金额",
    payType: "支付方式",
    sourceType: "订单来源",
    status: "订单状态",
    operations: "操作",
    viewOrder: "查看订单",
    closeOrder: "关闭订单",
    allOrder: "所有订单",
    deliverOrder: "发货订单",
    trackOrder: "追踪订单",
    deleteOrder: "删除订单",
    batchOperate: "批量操作",
    confirm: "确认",
    operationNote: "操作备注",
    enterContent: "输入内容",
    cancel: "取消",
    pendingPayment: "待付款",
    pendingShipment: "待发货",
    shipped: "已发货",
    completed: "已完成",
    closed: "已关闭",
    invalidOrder: "无效订单",
    normalOrder: "普通订单",
    flashOrder: "限时订单",
    pcOrder: "PC订单",
    appOrder: "APP订单",
    batchShipment: "批量发货",
    alipay: "线上支付宝",
    wechat: "线上微信",
    unpaid: "未付款",
    bank: "线下银行转账",
    paypal: "线上贝宝",
    blockchain: "线下区块链",
    others: "线下其他",
    cash:"线下现金",
    selectOrder: "请选择要操作的订单",
    noShippableOrder: "所选订单中无可发货订单",
    emptyNote: "操作备注不能为空",
    modifySuccess: "修改成功",
    deleteConfirmation: "您确定要删除吗？",
    prompt: "提示",
    deleteSuccess: "删除成功"
  },
  orderDetail: {
    remark:"备注",
    exceedAmount:"超出订单金额",
    chooseProduct:"选择产品:",
    confirmMarkOrder:"确认标记订单？",
    confirmCloseOrder:"确认取消订单？",
    confirmDeleteOrder:'确认删除订单？',
    delivery: "已发货",
    modifyPayStatus: "已付款",
    submitOrder: "提交订单",
    payOrder: "支付订单",
    platformDelivery: "平台发货",
    confirmReceipt: "确认收货",
    completeEvaluation: "完成评价",
    currentOrderStatus: "订单状态",
    modifyReceiverInfo: "修改收货人信息",
    modifyFeeInfo: "修改费用信息",
    sendMessage: "修改订单状态",
    closeOrder: "关闭订单",
    markOrder: "标记订单",
    cancelOrder: "取消订单",
    trackOrder: "跟踪订单",
    deleteOrder: "删除订单",
    basicInfo: "基本信息",
    orderNumber: "订单编号",
    deliverySerialNumber: "发货单号",
    userAccount: "用户账号",
    realName: "真实姓名",
    mobile: "手机号码",
    paymentMethod: "支付方式",
    balanceAmount: "入账金额",
    orderSource: "订单来源",
    orderType: "订单类型",
    deliveryMethod: "配送公司",
    logisticsNumber: "物流单号",
    autoConfirmReceiptTime: "自动确认收货",
    orderEarnPoints: "订单赚取积分",
    orderEarnGrowth: "订单赚取成长值",
    promotionInfo: "促销信息",
    receiverInfo: "收货人信息",
    receiver: "收货人",
    phoneNumber: "电话",
    postalCode: "邮政",
    address: "地址",
    productInfo: "商品信息",
    productImage: "商品图片",
    productName: "商品名称",
    brand: "品牌",
    price: "价格",
    productSn: "商品编号",
    attribute: "属性",
    quantity: "数量",
    subtotal: "小计",
    total: "总计",
    feeInfo: "费用信息",
    productTotal: "商品总额",
    freight: "运费",
    coupon: "优惠券",
    confirmReceiverUpdate:"你确定要修改收货人信息么？",
    confirmFeeUpdate:"你确定要修改费用信息么？",
    pointsDeduction: "积分抵扣",
    promotionDiscount: "促销折扣",
    discountAmount: "折扣金额",
    orderTotalAmount: "订单总金额",
    payableAmount: "应付金额",
    operationInfo: "操作信息",
    operator: "操作员",
    operationTime: "操作时间",
    orderStatus: "订单状态",
    paymentStatus: "支付状态",
    deliveryStatus: "配送状态",
    note: "备注",
    confirm: "确认",
    cancel: "取消",
    modifyProductInfo: "修改产品信息",
    add: "增加产品",
    updateReceiverInfo: "更新收货人信息",
    updateFeeInfo: "更新费用信息",
    sendStationMessage: "发送站内信",
    operationNote: "操作备注",
    addressDetail: "详细地址",
    selectRegion: "选择地区",
    selectProduct: "选择产品",
    successfulUpdate: "更新成功！",
    successfulSend: "消息发送成功！",
    successfulClose: "订单关闭成功！",
    successfulMark: "订单标记成功！",
    successfulDelete: "订单删除成功！",
    warning: "警告",
    prompt: "提示",
    pendingDelivery: '待发货',
    delivered: '已发货',
    completed: '已完成',
    closed: '已关闭',
    invalidOrder: '无效订单',
    pendingPayment: '待付款',
    unpaid: '未付款',
    refunded: '已退款',
    paid: '已付款',
    notShipped: "未发货",
    shipped: "已发货",
    empty:"无",
    appOrder: "App",
    pcOrder: "电脑",
    alipay: "线下支付宝",
    wechat: "线下微信",
    bank: "线下银行",
    paypal: "线下贝宝",
    onlinePaypal: "线上贝宝",
    blockchain: "线下区块链",
    others: "其他",
    normalOrder: "普通订单",
    seckillOrder: "秒杀订单",
    receiverName:"收货人姓名",
    country:"国家",
    city:"城市",
  },
  logisticsDialog: {
    orderTracking: "订单追踪",
    orderSubmitted: "订单已提交，等待支付",
    paymentSuccessful: "订单支付成功",
    scanInBeijing: "北京扫描中，等待支付",
    scanInShenzhen: "广东深圳枢纽卸货中，等待支付",
    dispatchInShenzhen: "广东深圳发货中",
    arrivalInShenzhen: "抵达广东深圳枢纽，即将送达",
    orderReceived: "订单已签收，期待再次为您服务"
  },
  deliverOrderList: {
    shippingList: "发货清单",
    orderNumber: "订单编号",
    receiver: "收货人",
    phoneNumber: "电话号码",
    postalCode: "邮政编码",
    address: "地址",
    deliveryMethod: "配送公司",
    selectLogisticsCompany: "请选择物流公司",
    trackingNumber: "物流单号",
    cancel: "取消",
    confirm: "确认",
    confirmShipping: "是否确认发货？",
    tip: "提示",
    shippingSuccess: "发货成功！",
    shippingCancelled: "发货已取消"
  },
  orderReturnApply: {
    filterSearch: "筛选查询",
    search: "搜索",
    reset: "重置",
    searchInput: "搜索输入：",
    status: "状态：",
    applyTime: "申请时间：",
    operator: "操作员：",
    handleTime: "处理时间：",
    dataList: "数据列表",
    serviceOrderNo: "服务单号",
    userAccount: "用户账号",
    refundAmount: "退款金额",
    applyStatus: "申请状态",
    operation: "操作",
    viewDetail: "查看详情",
    batchOperation: "批量操作",
    confirm: "确认",
    selectTime: "请选择时间",
    all: "全部",
    selectOperation: "请选择要操作的申请",
    confirmDelete: "是否确认删除？",
    tip: "提示",
    deleteSuccess: "删除成功！",
    pending: "待处理",
    returning: "退货中",
    completed: "已完成",
    rejected: "已拒绝",
    batchDelete: "批量删除"
  },
  orderReason: {
    dataList: "数据列表",
    add: "添加",
    id: "ID",
    reasonType: "原因类型",
    sort: "排序",
    status: "状态",
    addTime: "添加时间",
    operation: "操作",
    edit: "编辑",
    delete: "删除",
    batchOperation: "批量操作",
    confirm: "确认",
    addReason: "添加退货原因",
    enable: "启用",
    cancel: "取消",
    addSuccess: "添加成功！",
    updateSuccess: "更新成功！",
    statusUpdateSuccess: "状态更新成功",
    selectItems: "请选择要操作的项目",
    confirmDelete: "是否确认删除？",
    tip: "提示",
    deleteSuccess: "删除成功！"
  },
  orderApplyDetail: {
    returnGoods: "退货商品",
    productImage: "商品图片",
    productName: "商品名称",
    brand: "品牌",
    priceSku: "价格/SKU",
    price: "价格",
    sku: "SKU",
    attribute: "属性",
    quantity: "数量",
    subtotal: "小计",
    total: "总计",
    serviceOrderInfo: "服务单信息",
    serviceOrderNo: "服务单号",
    applyStatus: "申请状态",
    orderNo: "订单编号",
    view: "查看",
    applyTime: "申请时间",
    userAccount: "用户账号",
    contactName: "联系人姓名",
    contactPhone: "联系电话",
    returnReason: "退货原因",
    problemDescription: "问题描述",
    proofImages: "凭证图片",
    orderAmount: "订单金额",
    confirmRefundAmount: "确认退款金额",
    selectReceivingPoint: "选择收货点",
    receiverName: "收货人姓名",
    region: "地区",
    detailAddress: "详细地址",
    phone: "电话",
    handler: "处理人",
    handleTime: "处理时间",
    handleNote: "处理备注",
    receiver: "收货人",
    receiveTime: "收货时间",
    receiveNote: "收货备注",
    confirmReturn: "确认退货",
    rejectReturn: "拒绝退货",
    confirmReceive: "确认收货",
    confirmOperation: "是否确认此操作？",
    tip: "提示",
    operationSuccess: "操作成功！",
    pending: "待处理",
    returning: "退货中",
    completed: "已完成",
    rejected: "已拒绝"
  },
  hot: {
    filterSearch: "筛选查询",
    search: "搜索",
    reset: "重置",
    productName: "商品名称",
    recommendStatus: "推荐状态",
    all: "全部",
    dataList: "数据列表",
    selectProduct: "选择商品",
    id: "ID",
    isRecommended: "是否推荐",
    sort: "排序",
    status: "状态",
    operation: "操作",
    setSort: "设置排序",
    delete: "删除",
    batchOperation: "批量操作",
    confirm: "确认",
    productNameSearch: "商品名称搜索",
    productSn: "商品编号",
    price: "价格",
    cancel: "取消",
    setRecommended: "设为推荐",
    cancelRecommended: "取消推荐",
    notRecommended: "未推荐",
    recommended: "已推荐",
    selectRecord: "请选择一条记录",
    selectOperationType: "请选择批量操作类型",
    confirmAdd: "是否确认添加？",
    tip: "提示",
    addSuccess: "添加成功！",
    confirmUpdateSort: "是否确认更新排序？",
    updateSortSuccess: "排序更新成功！",
    confirmUpdateRecommendStatus: "是否确认更新推荐状态？",
    updateSuccess: "更新成功！",
    cancelOperation: "操作已取消！",
    confirmDelete: "是否确认删除推荐？",
    deleteSuccess: "删除成功！"
  },
  new: {
    filterSearch: "筛选查询",
    search: "搜索",
    reset: "重置",
    productName: "商品名称",
    recommendStatus: "推荐状态",
    all: "全部",
    dataList: "数据列表",
    selectProduct: "选择商品",
    id: "ID",
    isRecommended: "是否推荐",
    sort: "排序",
    status: "状态",
    operation: "操作",
    setSort: "设置排序",
    delete: "删除",
    batchOperation: "批量操作",
    confirm: "确认",
    productNameSearch: "商品名称搜索",
    productSn: "商品编号",
    price: "价格",
    cancel: "取消",
    setRecommended: "设为推荐",
    cancelRecommended: "取消推荐",
    notRecommended: "未推荐",
    recommended: "已推荐",
    selectRecord: "请选择一条记录",
    selectOperationType: "请选择批量操作类型",
    confirmAdd: "是否确认添加？",
    tip: "提示",
    addSuccess: "添加成功！",
    confirmUpdateSort: "是否确认更新排序？",
    updateSortSuccess: "排序更新成功！",
    confirmUpdateRecommendStatus: "是否确认更新推荐状态？",
    updateSuccess: "更新成功！",
    cancelOperation: "操作已取消！",
    confirmDelete: "是否确认删除推荐？",
    deleteSuccess: "删除成功！"
  },

  "advertiseIndex": {
    "cancel":"取消",
    "filterSearch": "筛选查询",
    "search": "搜索",
    "reset": "重置",
    "adName": "广告名称",
    "adPosition": "广告位置",
    "expireTime": "到期时间",
    "selectTime": "请选择时间",
    "dataList": "数据列表",
    "addAd": "添加广告",
    "id": "ID",
    "adImage": "广告图片",
    "time": "时间",
    "startTime": "开始时间",
    "status": "上下线状态",
    "clickCount": "点击次数",
    "orderCount": "订单数量",
    "operation": "操作",
    "edit": "编辑",
    "delete": "删除",
    "batchOperation": "批量操作",
    "confirm": "确认",
    "pcCarousel": "PC首页轮播",
    "appCarousel": "APP首页轮播",
    "confirmUpdateStatus": "是否确认更改上下线状态？",
    "tip": "提示",
    "updateSuccess": "更新成功！",
    "cancelOperation": "操作已取消！",
    "selectRecord": "请选择一条记录",
    "selectOperationType": "请选择批量操作类型",
    "confirmDelete": "是否确认删除此广告？",
    "deleteSuccess": "删除成功！"
  },
  "homeAdvertiseDetail": {
    "selectDate":"选择时间",
    "adName": "广告名称",
    "adPosition": "广告位置",
    "startTime": "开始时间",
    "expireTime": "到期时间",
    "status": "上下线状态",
    "adImage": "广告图片",
    "sort": "排序",
    "adUrl": "跳转商品",
    "adNote": "广告备注",
    "enterContent": "请输入内容",
    "submit": "提交",
    "reset": "重置",
    "pcCarousel": "PC首页轮播",
    "appCarousel": "APP首页轮播",
    "offline": "下线",
    "online": "上线",
    "enterAdName": "请输入广告名称",
    "nameLength": "长度在2到140个字符之间",
    "enterAdUrl": "请输入广告URL",
    "selectStartTime": "请选择开始时间",
    "selectExpireTime": "请选择到期时间",
    "selectAdImage": "请选择广告图片",
    "confirmSubmit": "是否确认提交数据？",
    "tip": "提示",
    "confirm": "确认",
    "cancel": "取消",
    "updateSuccess": "更新成功",
    "submitSuccess": "提交成功",
    "validationFailed": "验证失败"
  },
  "member": {
    mergeInfo: "源用户的订单信息将全部转入目标用户，目标用户基础信息保留，但目标用户基础信息空缺，则由源用户信息进行补充。",
    srcUser: "源用户",
    destUser: "目标用户",
    "filterSearch": "筛选查询",
    "queryResult": "查询结果",
    "inputSearch": "输入搜索",
    "username": "用户名",
    "id": "ID",
    "optional":"选填",
    "name": "真实姓名",
    "mobile": "手机",
    "companyName": "公司名",
    "country": "国家",
    "taxId": "证件号",
    "nickname": "昵称",
    "phone": "电话",
    "icon": "头像",
    "level": "等级",
    "applyStatus": "申请状态",
    "operation": "操作",
    "edit": "编辑",
    "add": "增加",
    "merge": "合并",
    "enterEmail": "输入邮箱地址",
    "memberStatus": "会员状态",
    "pleaseSelect": "请选择",
    "memberLevel": "会员等级",
    "confirm": "确认",
    "cancel": "取消",
    "showBrand": "显示品牌",
    "hideBrand": "隐藏品牌",
    "success": "成功",
    "reject": "拒绝",
    "confirmDelete": "是否确认删除此记录？",
    "tip": "提示",
    "deleteSuccess": "删除成功"
  },
  "navbar": {
    "home": "首页",
    "logout": "登出"
  },
  "menu": {
    balanceList:'收银管理',
    distributeList:'支付记录',
    link: '链接',
    relationList:'推荐人',
    click: '点击记录',
    rms: '推荐人',
    pay: '支付',
    "Shop": "商店",
    "products": "产品",
    "productList": "产品列表",
    "addProduct": "添加产品",
    "productCategories": "产品类别",
    "productAttrs": "产品属性",
    "brandManagement": "品牌管理",
    "orders": "订单",
    "orderList": "订单列表",
    "orderSettings": "订单设置",
    "returnApplicationHandling": "退货申请处理",
    "returnReasonSettings": "退货原因设置",
    "marketing": "营销",
    "flashSaleActivityList": "限时活动列表",
    "couponList": "优惠券列表",
    "brandRecommendations": "品牌推荐",
    "newProductRecommendations": "新品推荐",
    "popularRecommendations": "流行推荐",
    "specialRecommendations": "特别推荐",
    "bannerList": "置顶广告列表",
    "permissions": "权限",
    "userList": "用户",
    "roleList": "角色列表",
    "menuList": "菜单列表",
    "resourceList": "资源列表",
    "stores": "店铺",
    "storeList": "店铺列表",
    "addStore": "添加店铺",
    "users": "用户"
  },
  "editorImage": {
    "wait": "请等待所有图片上传成功或网络问题发生，请刷新页面并重新上传。"
  },

  pay:{
    select:"选择：",
    remark:"备注：",
    thankyou:"目前系统尚处于试用期，无需付款即可使用。在试用期结束后，才开始计算过期时间。万分感谢您付费支持系统开发，为表谢意，后续将赠送延长会员时间。",
    introduce:"介绍：",
    permission:"付款后开通卖家VIP权限。",
    title:"MyTrustStores卖家VIP会员",

    oneMonthLabel:"1个月 - $20.00 USD（原价 $100 USD)",
    threeMonthLabel:"3个月 - $60.00 USD（原价 $300 USD)",
    sixMonthLabel:"6个月 - $120.00 USD（原价 $600 USD)",
    oneYearLabel:"1年 - $240.00 USD（原价 $1200 USD)",
    threeYearLabel:"3年 - $720.00 USD（原价 $3600 USD)",
    sixYearLabel:"6年 - $1440.00 USD（原价 $7200 USD)",
  },

  relation:{
    ip:'IP',
    agent:'设备信息',
    code:'邀请码',
    clickTime:'点击时间',
    dialogRatio:'提成比例',
    setDefaultRatio:'设置默认提成比例',
    username:'用户名',
    referTime:'推荐时间',
    status:'状态',
    level:'等级',
    ratio:'提成比例',
    confirmAdjustRatio:'确认调整提成比例么?',
    adjustRatio:'调整比例',
  },

  link:{
    inviteCode:'推荐码',
    kind:'种类',
    createTime:'创建时间',
    createLink:"创建链接",
    all:"所有",
    onlyReferee:"只有推荐人",
    onlyMerchant:"只有商家",
    copyInviteUrl:"分享",
    success:"拷贝成功",
  },

  distribute:{
    reward:'奖励',
    username:'用户名',
    payUsername:"支付者用户名",
    payAmount:"支付金额",
    reason:"奖励原因",
    createTime:"创建时间",

  }
}



// WEBPACK FOOTER //
// ./src/locale/zh-Hans.js